module.exports = __webpack_public_path__ + "static/media/Lapita_icon_200px.8fc3b839.png";